<template lang="html">
    <div :class="{'detail-package-strip': true, 'need-second-sure': isSecondSure}" @click.stop.prevent="openPackage">
        <div class="touch-strip" v-if="prdTmpId !== 8  && baseInfo.classBrandId != 115">
            <div class="content" v-if="prdTmpId === 6">
                <!-- "定制师服务产品模版"  -->
                <h2>选择<span>套餐/数量</span></h2>
            </div>
            <div class="content" v-else>
                <h2>选择<span>{{prdTmpId === 4 ? '日期/套餐/数量' : '套餐类型/出发日期/出游人数'}}</span></h2>
                <p class="ahead-time">{{text}}</p>
            </div>
            <i class="arrow"></i>
        </div>
        <div class="second-sure-ctn">
            <div class="need" v-if="isSecondSure">
                <h3><img src="//m2.tuniucdn.com/fb2/t1/G5/M00/4E/99/Cii-slu8GnKIJ-ksAAACrxXReh8AAOuwAP__TkAAALH667.png">二次确认<span v-if="passRate">（历史通过率{{passRate}}）</span></h3>
                <p>支付成功后商家会尽快为您确认<span v-if="confirmDuration">，平均确认时长{{confirmDuration}}分钟</span></p>
            </div>
            <div class="no-need" v-else>
                <h3><img src="//m4.tuniucdn.com/fb2/t1/G5/M00/51/2C/Cii-s1u8GnGIdn-XAAADX9WZM14AAOzKgP__IkAAAN3374.png">立即确认<span>预订产品后立即确认订单，无需等待</span></h3>
            </div>
        </div>
    </div>
</template>

<script>
import {eventTrack} from '@/business/analy';
import { mapState } from 'vuex';
export default {
    name: 'calendar',

    props: {
        prdTmpId: {
            type: Number,
            default: function () {
                return 5
            }
        },
        isSecondSure: {
            type: Number,
             default: function () {
                return 0
            }
        },
        passRate: {
            type: String,
             default: function () {
                return ''
            }
        },
        confirmDuration: {
            type: Number,
             default: function () {
                return 0
            }
        },
        packageData: {
            type: Object,
            default: function () {
                return {}
            }
        },
        timeDifference: {
            type: Boolean,
             default: function () {
                return false
            }
        }
    },

    computed: {
        ...mapState({
            baseInfo: state => state.detail && state.detail.baseInfo
        }),
        text () {
            if (this.packageData && (this.packageData.bookDay || this.packageData.bookTime)) {
                return `${!this.packageData.uniformity ? '部分团期' : ''}${this.packageData.bookDay ? ('提前' + this.packageData.bookDay + '天') : '支持当天'}${this.packageData.bookTime || ''}前预订${this.timeDifference ? '(当地时间)' : ''}`;
            } else {
                return this.timeDifference ? '(日期为目的地当地时间)' : '';
            }
        }
    },

    methods: {
        /**
         * 打开套餐选择页
         */
        openPackage: function() {
            this.$router.push(this.getAppLink('/item/' + this.$route.params.id + '/package'));
            eventTrack('CLICK_INDEX_CALENDAR')
        }
    },

    filters: {
    }
}
</script>

<style lang="scss">
@import '../style/common.scss';
.detail-package-strip {
    overflow: hidden;
    border-radius: $borderBigRadius;
    background-color: #fff;
    background-repeat: no-repeat;
    background-image: url('https://m1.tuniucdn.com/fb2/t1/G5/M00/51/8C/Cii-s1u8GM-IeGb2AAAnHL8D5RgAAOz-AO0DuQAACc0600.png');
    background-size: 100%;
    background-position: bottom;
    margin-top: 9px;
    &.need-second-sure {
        background-image: url('https://m2.tuniucdn.com/fb2/t1/G5/M00/51/8C/Cii-slu8GM6ISzQqAAA4kpaGsBcAAOz-AOz1joAADiq000.png');
    }
    .touch-strip {
        display: block;
        padding: 13px 33px 13px 0;
        line-height: 24px;
        h2 {
            font-size: 18px;
            font-weight: 700;
            color: $fontStrongColor;
            span {
                font-weight: 300;
            }
        }
        p {
            font-size: 12px;
            font-weight: 300;
            color: #777893;
            margin-bottom: -7px;
        }
    }
    .second-sure-ctn {
        position: relative;
        &:before {
            content: '';
            position: absolute;
            top: 0;
            left: 18px;
            right: 18px;
            height: 1px;
            z-index: 1;
            background: linear-gradient(top, rgba(0, 0, 0, 0.05), transparent 50%, transparent);
        }
        & > div {
            padding: 12px 18px;
        }
        h3 {
            height: 24px;
            line-height: 24px;
            font-size: 15px;
            img {
                display: inline-block;
                width: 14px;
                height: 15px;
                margin-right: 3px;
            }
            span {
                font-size: 12px;
                margin-left: 2px;
            }
        }
        p {
            font-size: 12px;
            line-height: 18px;
            color: #777893;
        }
        .no-need {
            color: #ff6436;
        }
        .need {
            padding: 10px 18px;
            color: #32c45d;
        }
    }
}
</style>



// WEBPACK FOOTER //
// Calendar.vue